import { X_REPLY } from '@/lib/posts/postTypes';

import { BaseXTab, type BaseXTabProps } from '@/components/pages/myprofile/tabs/BaseXTab';

type RepliesXTabProps = Omit<
    BaseXTabProps,
    'initialParams' | 'renderFilters' | 'exportType' | 'hasFilter'
>;

const RepliesXTab = (props: RepliesXTabProps) => (
    <BaseXTab
        {...props}
        initialParams={{ filter_post_type: ['reply'] }}
        exportType={X_REPLY}
        hasFilter={false}
    />
);

export default RepliesXTab;
